<template>
    <div style="height:calc(100% - 65px)">
        <iframe v-if="selectPlugin != null && !isNewRegistrationMethod" id="show-plugin" ref="iframeConfigUI" style="width:100%;height:100%;" frameBorder=0></iframe>
        <binsBrowse 
        v-if="openBinsBrowse && !isNewRegistrationMethod"
        :workspaceList="['bins']"
        :enableAssetMultiSelect="false"
        @close="closeModal"
        @handleFilesBrowse="selectedBinPath"
        :enableRecursive="false"
        :browseOnlyFolders="true"
        style="z-index:99"
        :parentPreSelectedPathIds="selectedKeyInfo && selectedKeyInfo.value?[selectedKeyInfo.value]:''">
        </binsBrowse>
        <binsBrowse
          v-if="openCatalogsBrowse && !isNewRegistrationMethod"
          ref="catalogsBrowseModal"
          :workspaceList="catalogWorkspaceList"
          :enableAssetMultiSelect="false"
          @close="openCatalogsBrowse=false"
          @handleFilesBrowse="addSelectedCategoryId"
          :enableRecursive="false"
          :browseOnlyFolders="true"
          style="z-index:99">
        </binsBrowse>
         <component class="test-class" v-if="isNewRegistrationMethod" :key="pluginInfo.plugin_id" :is="currentcomponent" style="width:100%;height:100%;"></component>
    </div>
</template>


<script>
import {mapMutations,mapGetters} from "vuex";
import binsBrowse from "../files/filesBrowse.vue";
import Constants from "../../components.constants.js";
import Utils from "../../components.utils.js";

export default {
    data(){
      return{
        seletedPlugin:null,
        iframeController:null,
        registeredNotifications:[],
        openBinsBrowse:false,
        openCatalogsBrowse: false,
        selectedKeyInfo:null,
        catalogWorkspaceList:[Constants.WORKSPACE_CATALOG],
        currentcomponent:null,
        isNewRegistrationMethod:false,
      }
    },
    components:{
      binsBrowse
    },
    methods:{
         async loadPlugin(id){
            let plugin =  this.getRegisteredPluginMapper()[id];
            console.log("Plugin......",plugin);
            if(plugin && Object.prototype.hasOwnProperty.call(plugin,"configPluginLoadingInfo")){
                this.seletedPlugin = this.pluginInfo.plugin_name;
                this.isNewRegistrationMethod = true;
                let compInfo = await  Utils.loadPluginBundles([plugin.configPluginLoadingInfo.pluginBundle.js],plugin.configPluginLoadingInfo.eventName);
                Utils.loadCssBundle(plugin.configPluginLoadingInfo.pluginBundle.css);
                console.log("compInfo compInfo",compInfo);
                if(compInfo[0] && compInfo[0].pluginStore && Array.isArray(compInfo[0].pluginStore) && compInfo[0].pluginStore.length){
                    for(let i = 0; i < compInfo[0].pluginStore.length; i++){
                      if(!this.$store.hasModule(compInfo[0].pluginStore[i].module))
                        this.$store.registerModule(compInfo[0].pluginStore[i].module,compInfo[0].pluginStore[i].store); // registers store dynamically at run time
                    }
                }else{
                  if(compInfo[0] && compInfo[0].pluginStore && !this.$store.hasModule(compInfo[0].pluginStore.module))
                      this.$store.registerModule(compInfo[0].pluginStore.module,compInfo[0].pluginStore.store); // registers store dynamically at run time
                }

                this.$nextTick(()=>{
                      this.currentcomponent = compInfo[0].components;
                });
            }
         },
        selectPlugin(plugin){
          try{
            this.seletedPlugin = plugin
            this.loadExternalPluginConfigUI({id:this.pluginInfo.plugin_id,pluginName: this.seletedPlugin,tagId: "show-plugin"})// eslint-disable-line no-undef
            this.iframeController = this.$refs.iframeConfigUI.contentWindow
          }catch(e){
            console.log(e)
          }  
        },
        damNotificationCallback(notification){
          notification = notification.detail && Object.keys(notification.detail).length!=0?notification.detail:notification
          this.iframeController.postMessage({
                    cmd: 'damNotification',
                    params: Object.assign({}, notification)
                    }, '*')
        },
        closeModal(){
          this.openBinsBrowse = false;
        },
        selectedBinPath(folderInfoList){
          this.iframeController.postMessage({
            cmd: 'openBinsBrowse',
            params: {
              folderInfo:folderInfoList,
              selectedKeyData:this.selectedKeyInfo
            }
          }, '*')
          this.closeModal();
        },
        addSelectedCategoryId(folderInfoList){
          this.iframeController.postMessage({
            cmd: 'openCatalogsBrowse',
            params: {
              folderInfo:folderInfoList,
              selectedKeyData:this.selectedKeyInfo
            }
          }, '*')
          this.openCatalogsBrowse = false
        },
        listenMessagesFromChild(){
          window.addEventListener('message', (event)=>{
            let cmd = event.data.cmd
            switch (cmd) {
              case 'readyToListenMessage':{
                //your bussiness login goes here
                  // this.iframeController.postMessage({
                  //   cmd: 'fileinfo',
                  //   params: {
                  //     file_uid:'d42432342324342'
                  //   }
                  //   }, '*')
                  break;
                }
              case 'damNotification':{
                  let event_name = event.data.params.event_name
                  this.registeredNotifications.push({eventname:event_name, callback:this.damNotificationCallback, parent:"pluginConfig"})
                  this.addWSEventListener({eventname:event_name, callback:this.damNotificationCallback, parent:"pluginConfig"})
                  break;
                }
              case 'loggedInUserID':{
                this.iframeController.postMessage({
                    cmd: 'loggedInUserID',
                    params: {
                      user_id:this.getLoggedInUserId()
                    }
                    }, '*')
                  break;
              }
              case 'startUpData':{
                this.iframeController.postMessage({
                    cmd: 'startUpData',
                    params: {
                      strtupData:this.getStartUpDataFromInCache()
                    }
                    }, '*')
                  break;
              }
              case 'openBinsBrowse':{
                    console.log("event.dataevent.data",event.data)
                    this.openBinsBrowse = true;
                    this.selectedKeyInfo = event.data.params;
                  break;
              }
              case 'openCatalogsBrowse':{
                    console.log("event.dataevent.data",event.data)
                    this.openCatalogsBrowse = true;
                    this.selectedKeyInfo = event.data.params;
                  break;
              }
              default:
                break;
            }
          }
          )
        },
        ...mapGetters("startUpData",["getStartUpDataFromInCache"]),
        ...mapGetters("users",["getLoggedInUser","getLoggedInUserId","getLoggedInUserInfo"]),
        ...mapMutations("registry",["loadExternalPluginConfigUI"]),
        ...mapMutations("websocket",["addWSEventListener", "removeWSEventListener"]),
        ...mapGetters("registry",["getRegisteredPluginMapper"]),
    },
    props:["pluginInfo"],
    created(){
      this.listenMessagesFromChild()
    },
    mounted() {
      this.loadPlugin(this.pluginInfo.plugin_id);
       setTimeout(() => this.selectPlugin(this.pluginInfo.plugin_name), 100);
    },
    beforeDestroy(){
      for (const regnotification of this.registeredNotifications) {
        this.removeWSEventListener(regnotification)
      }
    }
}
</script>

